export type Localizations = {
  [key: string]: string
}

export enum Language {
  DUTCH = 'nl',
  FRENCH = 'fr'
}
